import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var InputField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _cn, _cn3;
  var autoComplete = _ref.autoComplete,
    name = _ref.name,
    required = _ref.required,
    autoFocus = _ref.autoFocus,
    value = _ref.value,
    onKeyDown = _ref.onKeyDown,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    disabled = _ref.disabled,
    invalid = _ref.invalid,
    type = _ref.type,
    _ref$fieldType = _ref.fieldType,
    fieldType = _ref$fieldType === void 0 ? 'default' : _ref$fieldType,
    placeholder = _ref.placeholder,
    errorMessage = _ref.errorMessage,
    addon = _ref.addon,
    tabIndex = _ref.tabIndex,
    hidden = _ref.hidden;
  var inputType = type || 'text';
  var hasError = invalid || Boolean(errorMessage);
  var maxLength = fieldType === 'pin' ? 1 : undefined;
  return /*#__PURE__*/_jsxs("div", {
    className: cn((_cn = {}, _defineProperty(_cn, styles['container'], true), _defineProperty(_cn, styles['container--hidden'], hidden), _defineProperty(_cn, styles['container--pin'], fieldType === 'pin'), _cn)),
    children: [/*#__PURE__*/_jsxs("div", {
      className: cn(styles['input-group'], _defineProperty({}, styles['input-group--required'], required)),
      children: [/*#__PURE__*/_jsx("input", {
        name: name,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        type: inputType,
        placeholder: placeholder,
        ref: ref,
        tabIndex: tabIndex,
        className: cn((_cn3 = {}, _defineProperty(_cn3, styles['input'], true), _defineProperty(_cn3, styles['input-disabled'], disabled), _defineProperty(_cn3, styles['input-invalid'], hasError), _cn3)),
        value: value,
        maxLength: maxLength,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        disabled: disabled
      }), addon && /*#__PURE__*/_jsx("div", {
        className: styles['input-addon'],
        "data-testid": "addon",
        children: addon
      })]
    }), errorMessage && /*#__PURE__*/_jsx("span", {
      className: styles['error-message'],
      children: errorMessage
    })]
  });
});
InputField.displayName = 'InputField';